import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Employer from "../Assets/Employer/Employer.png";
import { FaTimes } from "react-icons/fa";

const Enquiry = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    contact: "",
    email: "",
    company_type: "",
    employees: "",
    role: "",
    city: "",
  });

  const [captcha, setCaptcha] = useState({ num1: 0, num2: 0, answer: "" });
  const [captchaError, setCaptchaError] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    generateCaptcha();
  }, []);

  const generateCaptcha = () => {
    const num1 = Math.floor(Math.random() * 10) + 1; // Random number 1-10
    const num2 = Math.floor(Math.random() * 10) - 1; // Random number 1-10
    const num3 = Math.floor(Math.random() * 10) * 1; // Random number 1-10
    setCaptcha({ num1, num2, answer: "" });
  };

  const handleCaptchaChange = (e) => {
    setCaptcha({ ...captcha, answer: e.target.value });
    setCaptchaError("");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage("");
    setSuccessMessage("");

    if (parseInt(captcha.answer) !== captcha.num1 + captcha.num2) {
      setCaptchaError("Incorrect CAPTCHA. Please try again.");
      setLoading(false);
      generateCaptcha();
      return;
    }

    try {
      const response = await axios.post("http://localhost:8000/employerEnquiry/enquiry/", formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      setSuccessMessage("We will contact you soon!");
      setFormData({
        name: "",
        contact: "",
        email: "",
        company_type: "",
        employees: "",
        role: "",
        city: "",
      });
    } catch (error) {
      setErrorMessage(error.response?.data?.detail || error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="flex w-full max-w-6xl bg-white rounded-lg shadow-lg overflow-hidden">
        <div className="w-full md:w-1/2 flex flex-col items-center justify-center p-8 text-center">
          <div className="mb-6 p-4 border border-[#0077af] bg-white rounded-md text-center">
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Recruit with JobGenne</h2>
            <p className="text-gray-700 mb-4">Employ JobGenne to find and hire qualified candidates</p>
            <button className="bg-[#0077af] text-white px-6 py-3 rounded-md hover:bg-blue-600 w-full md:w-auto">
              Buy Plan
            </button>
          </div>
          <img src={Employer} alt="Employer" className="object-cover h-80 w-80 rounded-md mb-6" />
          <div className="mt-4 p-4 border border-[#0077af] bg-white rounded-md max-w-xs mx-auto text-center">
            <p className="text-gray-700 font-medium mb-2">Already have an Employer Account?</p>
            <button
              onClick={() => navigate("/EmployerLogin")}
              className="px-6 py-3 bg-[#0077af] text-white text-lg font-semibold rounded-md hover:bg-blue-600 mx-auto"
            >
              Login
            </button>
          </div>
        </div>

        <div className="w-full md:w-1/2 p-8 relative">
          <button
            onClick={() => navigate("/")}
            className="absolute top-6 right-7 text-gray-300 hover:text-red-600 transition-colors duration-300"
          >
            <FaTimes className="mr-2" />
          </button>
          {successMessage ? (
            <div className="text-center text-lg font-semibold text-green-600">
              {successMessage}
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              {[
                { label: "Name", type: "text", name: "name" },
                { label: "Contact Number", type: "tel", name: "contact" },
                { label: "Email ID", type: "email", name: "email" },
              ].map(({ label, type, name }) => (
                <div className="mb-4" key={name}>
                  <label className="block text-gray-700 font-bold">{label}</label>
                  <input
                    type={type}
                    name={name}
                    value={formData[name]}
                    onChange={handleChange}
                    className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder={`Enter your ${label.toLowerCase()}`}
                  />
                </div>
              ))}

              <div className="flex gap-4 mb-4">
                <div className="w-1/2">
                  <label className="block text-gray-700 font-bold">No. of Employees</label>
                  <input
                    type="number"
                    name="employees"
                    value={formData.employees}
                    onChange={handleChange}
                    className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter number of employees"
                  />
                </div>
                <div className="w-1/2">
                  <label className="block text-gray-700 font-bold">Role</label>
                  <input
                    type="text"
                    name="role"
                    value={formData.role}
                    onChange={handleChange}
                    className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter your role"
                  />
                </div>
              </div>

              <div className="flex gap-4 mb-4">
                <div className="w-1/2">
                  <label className="block text-gray-700 font-bold">City</label>
                  <input
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter your city"
                  />
                </div>
                <div className="w-1/2">
                  <label className="block text-gray-700 font-bold">Company / Consultant</label>
                  <input
                    type="text"
                    name="company_type"
                    value={formData.company_type}
                    onChange={handleChange}
                    className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Company / Consultant"
                  />
                </div>
              </div>

              {errorMessage && (
                <div className="text-red-500 mb-4 text-center">{errorMessage}</div>
              )}
              <div>
                <label className="text-gray-800 text-sm mb-2 block font-bold">CAPTCHA</label>
                <div className="flex items-center space-x-2 border border-gray-300 rounded-lg p-3 shadow-sm bg-gray-50">
                  <span className="text-gray-800 font-bold">{`${captcha.num1} + ${captcha.num2} = `}</span>
                  <input
                    type="number"
                    value={captcha.answer}
                    onChange={handleCaptchaChange}
                    className="w-16 text-center text-sm text-gray-800 border border-gray-300 px-2 py-2 rounded-lg outline-none focus:ring-2 focus:ring-[#0077af]"
                    placeholder="?"
                    required
                  />
                </div>
                {captchaError && <p className="text-red-600 text-sm mt-1">{captchaError}</p>}
              </div>

              <div className="flex justify-between mt-4">
                <button
                  type="submit"
                  disabled={loading}
                  className={`px-6 py-3 text-white text-lg font-semibold rounded-md w-full md:w-auto ${loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#0077af] hover:bg-blue-600'}`}
                >
                  {loading ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default Enquiry;
